// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"53":"app-messages-Spanish_Ext","139":"app-messages-en_US","225":"app-messages-ChineseWu_Ext","881":"product-metadata"}[chunkId] + "." + {"53":"5c625fdb","139":"f1dfbb3e","225":"32e7c24e","881":"6149eecb"}[chunkId] + ".chunk.js";
};